"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useIsModelPlaced = void 0;
const getIsModelPlaced_1 = require("../selectors/getIsModelPlaced");
const getModelIndicator_1 = require("../selectors/getModelIndicator");
const useSelector_1 = require("./useSelector");
function useIsModelPlaced(isModelIndicator) {
    const isModelPlaced = (0, useSelector_1.useSelector)(getIsModelPlaced_1.getIsModelPlaced);
    const modelIndicator = (0, useSelector_1.useSelector)(getModelIndicator_1.getModelIndicator);
    if (isModelIndicator) {
        return modelIndicator ? isModelPlaced : true;
    }
    return isModelPlaced;
}
exports.useIsModelPlaced = useIsModelPlaced;
